export const SAVE_CLUSTER_MASTER = "SAVE_CLUSTER_MASTER"
export const SAVE_CLUSTER_MASTER_SUCCESS = "SAVE_CLUSTER_MASTER_SUCCESS"

export const GET_CLUSTER_LIST = "GET_CLUSTER_LIST"
export const GET_CLUSTER_LIST_SUCCESS = "GET_CLUSTER_LIST_SUCCESS"

export const DELETE_CLUSTER_ID = "DELETE_CLUSTER_ID"
export const DELETE_CLUSTER_ID_SUCCESS = "DELETE_CLUSTER_ID_SUCCESS"

export const EDIT_CLUSTER_ID = "EDIT_CLUSTER_ID"
export const EDIT_CLUSTER_ID_SUCCESS = "EDIT_CLUSTER_ID_SUCCESS"

export const UPDATE_CLUSTER_ID = "UPDATE_CLUSTER_ID"
export const UPDATE_CLUSTER_ID_SUCCESS = "UPDATE_CLUSTER_ID_SUCCESS"

export const CLUSTER_API_ERROR_ACTION = "CLUSTER_API_ERROR_ACTION"